/**
 * Cupones de lanzamiento — fuente única en la web.
 *
 * Planes nuevos (Marco, 24-oct-2026): Free con toda la biblioteca, En Vivo
 * (código interno `pro`) a USD 99 y Premium a USD 199.
 *
 * Los cupones viven en Stripe (Catálogo de productos → Cupones):
 *   · ENVIVO79     → En Vivo USD 20 menos PARA SIEMPRE ($99 → $79)
 *   · LANZAPREMIUM → Premium USD 50 durante 3 meses ($199 → $149)
 * Se canjean hasta el 31-dic-2026. El checkout los aplica solo
 * (create-checkout con promo_code), así que nadie tiene que escribir el código.
 * LANZAMIENTO (Pro 50% × 3 meses) quedó desactivado.
 *
 * Los correos tienen su copia en supabase/functions/_shared/promo.ts. Si
 * cambias código, precio o fecha en Stripe, cámbialo en los dos lados.
 */
export type PromoFamily = 'pro' | 'premium';

export const LAUNCH_PROMO = {
  /** months: null = el descuento queda para siempre mientras siga suscrito. */
  pro: { code: 'ENVIVO79', priceCents: 7900, regularCents: 9900, months: null as number | null },
  premium: { code: 'LANZAPREMIUM', priceCents: 14900, regularCents: 19900, months: 3 as number | null },
  endsAt: '2026-12-31T23:59:59-05:00',
  endsLabel: '31 de diciembre',
} as const;

export function isLaunchPromoActive(now: number = Date.now()): boolean {
  return now < Date.parse(LAUNCH_PROMO.endsAt);
}

/** Código a mandar al checkout para esa familia (o undefined si no hay promo). */
export function promoCodeFor(family: PromoFamily): string | undefined {
  return isLaunchPromoActive() ? LAUNCH_PROMO[family].code : undefined;
}

function usd(cents: number): string {
  return cents % 100 === 0 ? `$${cents / 100}` : `$${(cents / 100).toFixed(2)}`;
}

/** "$79" / "$149" — precio de lanzamiento listo para mostrar. */
export function promoPriceLabel(family: PromoFamily): string {
  return usd(LAUNCH_PROMO[family].priceCents);
}

/**
 * Cuánto dura el precio de lanzamiento, para poner al lado del precio:
 * En Vivo → "para siempre si entras antes del 31 de diciembre";
 * Premium → "los primeros 3 meses, luego $199".
 */
export function promoDuracion(family: PromoFamily): string {
  const p = LAUNCH_PROMO[family];
  return p.months == null
    ? `para siempre si entras antes del ${LAUNCH_PROMO.endsLabel}`
    : `los primeros ${p.months} meses, luego ${usd(p.regularCents)}`;
}
